function getConfig() {
  // Different config depending on environment
  if (process.env.NODE_ENV === 'production') {
    return {
      apiBaseUrl: 'https://api-translator.mondly.org',
      frontBasename: '/',
      imgStorage:  'https://d2kqfsx26podrr.cloudfront.net/tools/translator-resources/screenshots/'
    }
  } else {
    return {
      apiBaseUrl: 'http://localhost:3000',
      frontBasename: '/',
      imgStorage: '/img/'
    }
  }
}

export const CONFIG = getConfig();
